import { titlifyEnum } from '@utils/stringHelpers';

const STATUS_COLOR_MAP: Record<string, string> = {
	ACCEPTED: 'bg-green-200 text-black',
	ARRIVED: 'bg-amber-100 text-amber-900',
	AWAITING_CONFIRMATION: 'text-black bg-yellow-200',
	AWAITING_DELIVERY: 'bg-cyan-100 text-cyan-900',
	CANCELLED: 'bg-red-200 text-red-800',
	DRAFT: 'bg-gray-300 text-black',
	NOT_ACCEPTED: 'bg-red-200 text-red-800',
	PARTIALLY_ACCEPTED: 'bg-glazier-blue-200 text-glazier-blue-900',
	VOID: 'bg-purple-200 text-purple-800',
};
const DEFAULT_STATUS_COLOR = 'bg-glazier-blue-100 text-gray-700';

export const purchaseOrderStatusClasses = (status: string): string => STATUS_COLOR_MAP[status] ?? DEFAULT_STATUS_COLOR;

export const PurchaseOrderStatusBadge = ({
	status,
	includeMarginLeft = true,
	isSmall = false,
}: {
	status: string;
	includeMarginLeft?: boolean;
	isSmall?: boolean;
}) => {
	const className = isSmall
		? `inline-flex items-center rounded-full px-2 py-0.5 text-sm font-medium text-center ${purchaseOrderStatusClasses(status)}`
		: `shadow-md border border-gray-300 ${
				includeMarginLeft ? 'md:ml-3' : undefined
			} inline-flex items-center rounded-md px-2.5 py-0.5 text-med font-semibold text-center ${purchaseOrderStatusClasses(status)}`;

	return <span className={className}>{titlifyEnum(status)}</span>;
};
